import * as React from 'react';

export const InnerModalContext = React.createContext({
  isInnerModalOpen: false,
  setIsInnerModalOpen: (_value: boolean) => {},
});
